import axios from 'axios'

export default {

  validatePassword(token, password) {
    return axios({
      method: 'post',
      url: 'external/emails/' + token + '/validate-password',
      data: { password }
    })
  }
}
